import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { NoticeListsForNoticeQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const noticeListsForNoticeQuery = graphql(`
  query noticeListsForNotice($noticeGuid: String!) {
    noticeListsForNotice(noticeGuid: $noticeGuid) {
      id
      guid
      name
    }
  }
`);

export function useNoticeListsForRecord(
  recordGuid: string,
  options?: UseQueryOptions<
    NoticeListsForNoticeQuery,
    unknown,
    NoticeListsForNoticeQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["noticeLists", recordGuid],
    noticeListsForNoticeQuery,
    [{ noticeGuid: recordGuid }],
    options,
  );
  return { data: data?.noticeListsForNotice, ...rest };
}
